<template>
  <div v-if="!progress">
    <v-container>
      <v-card-title>
        <h5>{{ student.fullName() }}</h5>
      　<h6>　さん　</h6>
      <span><h6>{{ '('+ student.grade().toJapanese() + '  ' + student.genderInJapanese() + ')'}}</h6></span>
      </v-card-title>
      <v-divider></v-divider>
      <TeacherLessonDetails
        v-for="lesson in this.filteredLessons.get()"
        :key="lesson.id"
        :lesson="lesson"
        :student="student"
        @deleteLesson="deleteLesson(lesson)"
      />
      <v-dialog
        v-model="hasDeleted"
        max-width="500"
        persistent>
        <v-card>
          <v-card-title>
            授業を削除しました。
          </v-card-title>
          <v-container>
            <v-row justify="end">
            <v-card-actions>
              <v-btn
                class="ma-1"
                outlined
                rounded
                @click="hasDeleted=false">
                はい
              </v-btn>
            </v-card-actions>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <VProgress
        v-model="inProgress"
        :message="'削除しています…'"
      />
      <div>
        <v-card-actions>
          <v-btn
            text
            color="primary"
            @click="isMessage=true">
            家庭へメッセージを送る
          </v-btn>
        </v-card-actions>
      </div>
      <MessageFromParent
        v-if="isMessage"
        :parent="parent"
        :isOpen="isMessage"
        @open="isMessage=true"
        @close="isMessage=false"
      />
    </v-container>
    <v-divider></v-divider>
  </div>
</template>

<script>
import { firestore } from '@/repository/client/firestore.js'
import { LessonDeleter } from '@/service/lesson/delete-lesson.js'
import { ParentRepository } from '@/repository/ParentRepository.js'
import MessageFromParent from "@/components/organisms/teacher/MessageFromParent.vue"
import TeacherLessonDetails from '@/components/organisms/teacher/TeacherLessonDetails.vue'
import VProgress from '@/components/organisms/VProgress.vue'

export default {
  name:'LessonScheduleCard',
  components: {
    "TeacherLessonDetails": TeacherLessonDetails,
    "MessageFromParent": MessageFromParent,
    "VProgress": VProgress
  },
  props:{
    student: Object,
    lessons: Object,
  },
  data() {
    return {
      teacher: this.$store.getters.teacher,
      parent: null,
      hasDeleted: false,
      isMessage: false,
      filteredLessons: {},
      progress: true,
      inProgress: false
    }
  },
  methods: {
    async deleteLesson(lesson) {
      this.inProgress = true
      const deleter = new LessonDeleter(firestore, this.teacher)
      this.teacher = await deleter.execute(lesson.id)
      this.$store.commit("loginAsTeacher", this.teacher)
      this.filteredLessons.remove(lesson)
      if (this.filteredLessons.get().length === 0) {
        this.$emit("deleteStudent", this.student)
      }
      this.inProgress = false
      this.hasDeleted = true
    }
  },
  async created() {
    const parentRepo = new ParentRepository(firestore)
    this.parent = await parentRepo.find(this.student.parentId)
    this.filteredLessons = this.lessons.filterByStudentId(this.student.id)
    this.progress = false
  }
}
</script>